(ns yardwerkz.web.profile.payment-history
  "Payment transaction history with formatted amounts and dates."
  (:require
   [uix.core :refer [defui $ use-effect]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

;; =============================================================================
;; Helpers
;; =============================================================================

(defn- format-amount [amount-cents]
  (when amount-cents
    (str "$" (.toFixed (/ amount-cents 100) 2))))

(defn- format-date [date-val]
  (when date-val
    (try
      (let [d (if (string? date-val) (js/Date. date-val) date-val)]
        (str (inc (.getMonth d)) "/" (.getDate d) "/" (.getFullYear d)))
      (catch :default _ (str date-val)))))

(defn- status-class [status]
  (case (some-> status keyword)
    :succeeded "text-green-600"
    :completed "text-green-600"
    :pending "text-amber-600"
    :failed "text-red-600"
    :refunded "text-blue-600"
    "text-gray-600"))

;; =============================================================================
;; Transaction Row
;; =============================================================================

(defui transaction-row [{:keys [tx]}]
  (let [amount (or (:amount tx) (:payment/amount tx))
        status (or (:status tx) (:payment/status tx))
        date (or (:date tx) (:created-at tx) (:payment/created-at tx))
        desc (or (:description tx) (:service-name tx) "Payment")]
    ($ ui/card {:class "p-4"}
       ($ :div {:class "flex items-center justify-between"}
          ($ :div {:class "flex items-center space-x-3"}
             ($ :div {:class "p-2 bg-gray-100 rounded-lg"}
                ($ icons/DollarSign {:size 18 :class "text-gray-500"}))
             ($ :div
                ($ :p {:class "font-medium text-gray-900"} desc)
                ($ :div {:class "flex items-center space-x-2 mt-0.5"}
                   ($ :p {:class "text-xs text-gray-500"} (format-date date))
                   (when status
                     ($ :span {:class (str "text-xs font-medium " (status-class status))}
                        (name status))))))
          ($ :span {:class "font-semibold text-gray-900"}
             (or (format-amount amount) (:display-amount tx) ""))))))

;; =============================================================================
;; Page
;; =============================================================================

(defui payment-history-page []
  (let [dispatch (rfx/use-dispatch)
        history (rfx/use-sub [::store/payment-history])]

    (use-effect
     (fn []
       (dispatch [::store/fetch-payment-history])
       js/undefined)
     [dispatch])

    ($ layout/page-container
       ($ :button {:class "flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
                   :on-click #(router/navigate! :profile)}
          ($ icons/ChevronLeft {:size 16})
          ($ :span "Back to Profile"))
       ($ :h1 {:class "text-2xl font-bold text-gray-900 mb-6"} "Payment History")
       (if (seq history)
         ($ :div {:class "space-y-3"}
            (for [tx history]
              ($ transaction-row {:key (or (:id tx) (random-uuid))
                                  :tx tx})))
         ($ ui/empty-state
            {:icon ($ icons/History {:size 48})
             :title "No payment history"
             :description "Your transaction history will appear here."})))))
